import React from "react";

const GenderSelect = ({ selectedGender, onGenderChange, error }) => {
  const genders = [
    {
      value: "MALE",
      label: "Male",
    },
    {
      value: "FEMALE",
      label: "Female",
    },
  ];

  return (
    <div className="w-full">
      <div className="flex gap-3">
        {genders.map((gender) => (
          <div key={gender.value} className="flex-1">
            <input
              className="peer sr-only"
              value={gender.value}
              name="gender"
              id={gender.value}
              type="radio"
              checked={selectedGender === gender.value}
              onChange={() => onGenderChange(gender.value)}
            />
            <label
              htmlFor={gender.value}
              className={`flex h-12 w-full items-center justify-center rounded-lg border-2 ${
                error ? "border-red-500" : "border-gray-300"
              } bg-gray-50 p-1 transition-all duration-150 hover:border-blue-400 active:scale-[98%] peer-checked:border-blue-500 peer-checked:shadow-md peer-checked:shadow-blue-400/30 cursor-pointer`}
            >
              <span className="text-sm font-medium text-gray-800 peer-checked:text-blue-500">
                {gender.label}
              </span>
            </label>
          </div>
        ))}
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default GenderSelect;